import React, { PureComponent, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames/bind'
import { localize } from 'helpers/translator'
import { blockedWords } from 'helpers/social/cse'

import styles from './CSESearch.scss'
import NearpodPickerBottomBar from '../../../nearpod_picker/components/bottom_bar/nearpod_picker_bottom_bar'

const cx = classNames.bind(styles)

class CSESearch extends PureComponent {

	setElement = elem => {
		this.element = elem
	}

	state = {
		hasSelected: false,
		isBlocked: false,
	}

	componentDidMount() {
		try {
			window.__gcse['searchCallbacks']['image']['ready'] = this.onImagesReady
			window.__gcse['searchCallbacks']['image']['starting'] = this.onSearchStarting
			window.google.search.cse.element.render(
				{
					div: 'cse-image-search',
					tag: 'searchbox',
				},
				{
					div: 'cse-image-search-results',
					tag: 'searchresults',
					attributes: {
						enableAutoComplete: true,
						enableImageSearch: true,
						defaultToImageSearch: true,
						disableWebSearch: true,
						imageSearchLayout: 'column',
					},
				}
			)
		} catch (err) {
		}
	}

	onSearchSelection(index) {
		this.props.onSearchSelection(index, 'image')
	}

	onSearchStarting = (gname, query) => {
		if (query.match(blockedWords)) {
			this.setState({
				isBlocked: true,
			})
			query = 'blocked'
		} else {
			this.setState({
				isBlocked: false,
			})
		}
		return query
	}

	onImagesReady = (name, q, promos, results, resultsDiv) => {
		const formattedResults = results.map(result => (
			{
				thumbnail: result.thumbnailImage.url,
				link: result.image.url,
				title: result.content,
				size: 1,
			}
		))
		this.props.onResults(formattedResults)
		resultsDiv.appendChild(this.element)
		this.setState({
			hasSelected: false,
		})
		return true
	}

	buildImages() {
		const results = this.state.isBlocked ? [] : this.props.results
		return results.map((result, index) => (
			<li
				className={cx(
					{ 'image-results-list-item': true },
					{ 'image-results-list-item--selected': this.props.selected.includes(index) }
				)}
				key={index}
				onClick={() => {
					this.onSearchSelection(index)
				}}
			>
				<div className={styles['image-results-list-item-image']} style={{ backgroundImage: 'url(' + result.thumbnail + ')' }}></div>
			</li>
		))
	}

	saveHandler = () => {
		this.setState({
			hasSelected: true,
		})
		this.props.onSave()
	}

	cancelHandler = () => {
		this.setState({
			hasSelected: true,
		})
	}

	render() {
		return (
			<Fragment>
				<div
					id='cse-image-search'
					styleName={'cse-image-search-box'}
				/>
				<div
					className={cx(
						{ 'cse-image-search-results': true },
						{ 'cse-image-search-results--hidden': this.state.hasSelected }
					)}
					styleName="cse-image-search-results"
					id="cse-image-search-results"
				/>
				<div
					ref={this.setElement}
					className={cx(
						{ 'image-results-container': true },
						{ 'image-results-container--hidden': this.state.hasSelected || !this.props.results.length},
						{ 'image-results-container--blocked': this.state.isBlocked}
					)}
				>
					<ul
						styleName='image-results-list'
					>
						{this.buildImages()}
					</ul>
					<div
						styleName='image-results-blocked'
					>
						This content is blocked
					</div>
					<NearpodPickerBottomBar
						cancelText = {localize('global_back')}
						cancelHandler={this.cancelHandler}
						saveHandler={this.saveHandler}
						saveButtonEnabled={!!this.props.selected.length}
					/>
				</div>
			</Fragment>
		)
	}

}

export default CSSModules(CSESearch, styles, {allowMultiple: true})
